import { routes } from "../../../app/paths";
import { LogicalLinkTarget } from "./types";

// The only place where LogicalLinkTarget -> in-app route mapping happens.
export const resolveLogicalLinkRoute = (
  target: LogicalLinkTarget,
): string | undefined => {
  switch (target.type) {
    case "TALENT_PROFILE":
      return routes.talentProfile(target.talentId);
    case "TALENT_EMPLOYMENT":
      return routes.talentEmployment(target.talentId, target.employmentId);
    case "TALENT_EMPLOYMENTS":
      return `/home/talents/${target.talentId}/employment`;
    case "WORK_AGREEMENT_EDIT":
      return routes.workAgreementEdit(target.bundleId, target.workAgreementId);
    case "ORDER":
      return routes.orderEdit(target.bundleId);
    case "TALENT_ASSIGNMENT":
      return routes.talentAssignment(target.talentId, target.assignmentId);
    case "TALENT_ENTRIES":
      return `/home/talents/${target.talentId}/entries`;
    default: {
      // Degrade to "no link"
      const unsupported: never = target;
      console.error(
        `resolveLogicalLinkRoute: unsupported target type ${JSON.stringify(unsupported)}`,
      );
      return undefined;
    }
  }
};
